<template>
  <div class="block block-cust">
    <img :src="bg" class="img-responsive img-bg" alt="" />
    <div class="main-position">
      <div class="container">
        <div class="main">
          <div>
            <div class="title title-cust">关于我们</div>
            <div class="title2">ABOUT US</div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bg from "@/assets/images/about/bg.png";

export default {
  data() {
    return {
      bg,
    };
  },
};
</script>

<style scoped>
.block-cust {
  position: relative;
  padding: 0;
}
.main-position {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
}
.main {
  color: #fff;
  text-align: center;
}

.title-cust {
  font-size: 32px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  display: inline-block;
  padding-bottom: 5px;
}

.title2 {
  font-size: 16px;
  text-align: center;
  color: #ccc;
}
.img-bg {
  min-height: 300px;
}

/*  */
.mb .title-cust {
  font-size: 20px;
}
.mb .title2 {
  font-size: 14px;
}
</style>